function updateFromBundlex() {
  const active = document.querySelector('.bx-offer-wrap.bx-active');
  if (!active) return;

  // 🔹 Preis aus Bundlex-UI lesen
  const priceEl = active.querySelector('.bx-discounted-price');
  if (!priceEl) return;

  const priceText = priceEl.innerText
    .replace('€', '')
    .replace('.', '')
    .replace(',', '.')
    .trim();

  const total = Number(priceText);
  if (isNaN(total)) return;

  // 🔹 Menge = Anzahl der Variant-Selects
  const qty = active.querySelectorAll('.bx-variant-group').length || 1;

  const unit = total / qty;

  document.getElementById('ahgi-total').innerText =
    total.toFixed(2).replace('.', ',') + ' €';

  document.getElementById('ahgi-unit').innerText =
    unit.toFixed(2).replace('.', ',') + ' € / Stück';
}

// 🔥 Beobachte Bundlex selbst
const observer = new MutationObserver(updateFromBundlex);

document.addEventListener('DOMContentLoaded', () => {
  const widget = document.querySelector('.bx-widget-container');
  if (!widget) return;

  observer.observe(widget, {
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });

  updateFromBundlex();
});
